import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import UserMarketing from './Marketing';
import UserManagement from './UserManagement';
import SingleUser from './SingleUser';
import Ratings from './Ratings';
import PromotionalCodesManagement from './PromotionalCodesManagement';
import NewPersonalCreditCodes from './NewPersonalCreditCodes';
import NewPromotionalCodes from './NewPersonalCreditCodes';
import NewSignupCodes from './NewSignupCodes';
import SinglePersonalCreditCodes from './SinglePersonalCreditCodes';
import SinglePromotionalCodes from './SinglePersonalCreditCodes';
import SingleSignupCodes from './SingleSignupCodes';

class UserRelationship extends Component {

    render () {
        return (
            <Switch>
                <Route path="/user-relationship/users" exact component={ UserManagement } />
                <Route path="/user-relationship/users/:id" exact component={ SingleUser } />
                <Route path="/user-relationship/users/:id/ratings" component={ Ratings } />
                <Route path="/user-relationship/marketing" component={ UserMarketing } />
                <Route path="/user-relationship/promotional-codes-management" component={ PromotionalCodesManagement } />
                <Route path="/user-relationship/new-personal-credit-codes" exact  component={ NewPersonalCreditCodes } />
                <Route path="/user-relationship/new-promotional-codes" exact  component={ NewPromotionalCodes } />
                <Route path="/user-relationship/new-signup-codes" exact  component={ NewSignupCodes } />
                <Route path="/user-relationship/single-personal-credit-codes" exact  component={ SinglePersonalCreditCodes } />
                <Route path="/user-relationship/single-promotional-codes" exact  component={ SinglePromotionalCodes } />
                <Route path="/user-relationship/single-signup-codes" exact  component={ SingleSignupCodes } />
            </Switch>
        )
    }
}

export default UserRelationship;



// WEBPACK FOOTER //
// ./src/components/User-relationship/index.js